var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    staticStyle: {
      "float": "right",
      "padding-left": "0px",
      "padding-right": "0px",
      "margin-left": "11px"
    },
    attrs: {
      "type": "button",
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        _vm.refreshTickeSummary()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh text-primary",
    staticStyle: {
      "font-size": "17px"
    }
  })]), _vm._v(" "), (_vm.HubNameDiv) ? _c('basic-select', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "margin-top": "-8px",
      "height": "30px",
      "min-height": "25px",
      "padding": "7px",
      "font-size": "0.9rem",
      "margin-right": "9px"
    },
    attrs: {
      "id": "HubName",
      "options": _vm.HubOptionObj,
      "selected-option": _vm.HubSelectOptionObj
    },
    on: {
      "select": _vm.selectHub
    }
  }) : _vm._e(), _vm._v(" "), (_vm.clientListButton) ? _c('basic-select', {
    staticStyle: {
      "float": "right",
      "width": "25%",
      "margin-top": "-8px",
      "height": "30px",
      "min-height": "25px",
      "padding": "7px",
      "font-size": "0.9rem",
      "margin-right": "9px"
    },
    attrs: {
      "id": "ClientName",
      "options": _vm.clientlistObj,
      "selected-option": _vm.clientlistOptionObj
    },
    on: {
      "select": _vm.selectClient
    }
  }) : _vm._e(), _vm._v(" "), (_vm.clientListSpan) ? _c('span', {
    staticStyle: {
      "color": "red",
      "float": "right",
      "margin-right": "9px"
    }
  }, [_vm._v("Client not\n\t\t\t\t\t\t\tassigned\n\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row top_row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card top_cards_main"
  }, [_c('div', {
    staticClass: "card-header top_cards"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-number"
  }, [_c('a', {
    staticClass: "text_sub_head",
    attrs: {
      "href": "#/b2b/dashboard"
    },
    on: {
      "click": function($event) {
        _vm.b2bEnquirymodal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.TicketsSummery.Inquiry.TotalCound))])]), _vm._v(" "), _c('div', {
    staticClass: "view-details"
  }, [_c('a', {
    staticClass: "text_noti",
    attrs: {
      "href": "#/b2b/dashboard"
    },
    on: {
      "click": function($event) {
        _vm.b2bEnquirymodal = true
      }
    }
  }, [_vm._v("View Details")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card top_cards_main"
  }, [_c('div', {
    staticClass: "card-header top_cards"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-number"
  }, [_c('a', {
    staticClass: "text_sub_head",
    attrs: {
      "href": "#/b2b/dashboard"
    },
    on: {
      "click": function($event) {
        _vm.b2bRequestmodal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.TicketsSummery.Request.TotalCound))])]), _vm._v(" "), _c('div', {
    staticClass: "view-details"
  }, [_c('a', {
    staticClass: "text_noti",
    attrs: {
      "href": "#/b2b/dashboard"
    },
    on: {
      "click": function($event) {
        _vm.b2bRequestmodal = true
      }
    }
  }, [_vm._v("View Details")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card top_cards_main"
  }, [_c('div', {
    staticClass: "card-header top_cards"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-number"
  }, [_c('a', {
    staticClass: "text_sub_head",
    attrs: {
      "href": "#/b2b/dashboard"
    },
    on: {
      "click": function($event) {
        _vm.b2bcomplaintmodal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.TicketsSummery.Complaint.TotalCound))])]), _vm._v(" "), _c('div', {
    staticClass: "view-details"
  }, [_c('a', {
    staticClass: "text_noti",
    attrs: {
      "href": "#/b2b/dashboard"
    },
    on: {
      "click": function($event) {
        _vm.b2bcomplaintmodal = true
      }
    }
  }, [_vm._v("View\n\t\t\t\t\t\t\t\t\t\t\t\tDetails")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-close-on-esc": true,
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.TicketsSummery.Ticketsummerymodal = false
      }
    },
    model: {
      value: (_vm.TicketsSummery.Ticketsummerymodal),
      callback: function($$v) {
        _vm.TicketsSummery.Ticketsummerymodal = $$v
      },
      expression: "TicketsSummery.Ticketsummerymodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.TicketsSummery.Ticketsummerymodal),
      expression: "TicketsSummery.Ticketsummerymodal"
    }],
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px",
      "padding": "20px"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.TicketsSummery.TicketTypeName))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeTicketsummerymodal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: " form-control col-md-3",
    staticStyle: {
      "float": "right",
      "margin-right": "23px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Shipping Id/Source/Sub Reason",
      "title": "Search Shipping Id/Source/Sub Reason"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.OnFilterClick,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showEditBulkButton == true) ? _c('div', [_c('router-link', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "to": {
        name: 'bulkshipment',
        params: {
          message: 'edit_bulk_tickets',
          ticketSummeryListforBulkEdit: _vm.ticketSummeryListforBulkEdit,
          businessFlowObj: _vm.SummarySelectOptionObj,
          clientName: _vm.clientlistOptionObj.text,
          useridBulk: _vm.useridBulk,
          deptidBulk: _vm.deptidBulk,
          hubObj: _vm.HubSelectOptionObj,
          type: _vm.type,
          userClientNameBulk: _vm.userClientNameBulk
        }
      }
    }
  }, [_vm._v("Bulk Update")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table-responsive table-bordered",
    staticStyle: {
      "width": "100%",
      "max-width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ticket Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ticket Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Reattempt Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Type Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Source")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sub Reason")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.TicketsSummery.TicketSummeryList), function(TicketsSummeryele, index) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'b2btrackshipmentdetail',
          params: {
            id: TicketsSummeryele.shippingid
          }
        },
        "event": _vm.b2btrackShipmentAccess == true ? 'click' : ''
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(TicketsSummeryele.shippingid))])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.ticketid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.ticketstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.reattemptdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.reasonid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.sourceid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.subreasonid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(_vm._f("formatDatesingle")(TicketsSummeryele.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(TicketsSummeryele.createdby))])])
  }))]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  }), _vm._v(" "), (_vm.pagecount > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.pagecount,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.b2bEnquirymodal = false
      }
    },
    model: {
      value: (_vm.b2bEnquirymodal),
      callback: function($$v) {
        _vm.b2bEnquirymodal = $$v
      },
      expression: "b2bEnquirymodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.b2bEnquirymodal),
      expression: "b2bEnquirymodal"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Enquiry")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.b2bEnquirymodal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.TicketsSummery.Inquiry.InquiryData), function(Inquiryele, index) {
    return _c('div', {
      staticClass: "enq_container top_container_holdr"
    }, [_c('p', {
      staticClass: "enq_name"
    }, [_c('a', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "href": '#/b2b/dashboard'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Inquiryele.subResone, '', 'Inquiry')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Inquiryele.Name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
      staticClass: "enq_number"
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '#/b2b/dashboard'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Inquiryele.subResone, '', 'Inquiry')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Inquiryele.Values) + "\n\t\t\t\t\t\t")])])])
  }), _vm._v(" "), (_vm.TicketsSummery.Inquiry.TotalCound <= 0) ? _c('div', [_c('div', {
    staticClass: "text-center text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\ttickets\n\t\t\t\t\t")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.b2bRequestmodal = false
      }
    },
    model: {
      value: (_vm.b2bRequestmodal),
      callback: function($$v) {
        _vm.b2bRequestmodal = $$v
      },
      expression: "b2bRequestmodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.b2bRequestmodal),
      expression: "b2bRequestmodal"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Request")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.b2bRequestmodal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.TicketsSummery.Request.RequestData), function(Requestele, index) {
    return _c('div', {
      staticClass: "rq_container top_container_holdr"
    }, [_c('p', {
      staticClass: "rq_name"
    }, [_c('a', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "href": '#/b2b/dashboard'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Requestele.subResone, '', 'Request')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Requestele.Name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
      staticClass: "rq_number"
    }, [_c('a', {
      attrs: {
        "href": '#/b2b/dashboard'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Requestele.subResone, '', 'Request')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Requestele.Values) + "\n\t\t\t\t\t\t")])])])
  }), _vm._v(" "), (_vm.TicketsSummery.Request.TotalCound <= 0) ? _c('div', [_c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\ttickets\n\t\t\t\t\t")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.b2bcomplaintmodal = false
      }
    },
    model: {
      value: (_vm.b2bcomplaintmodal),
      callback: function($$v) {
        _vm.b2bcomplaintmodal = $$v
      },
      expression: "b2bcomplaintmodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.b2bcomplaintmodal),
      expression: "b2bcomplaintmodal"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Complaint")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.b2bcomplaintmodal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.TicketsSummery.Complaint.ComplaintData), function(Complaintele, index) {
    return _c('div', {
      staticClass: "comp_container top_container_holdr"
    }, [_c('p', {
      staticClass: "comp_name"
    }, [_c('a', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "href": '#/b2b/dashboard'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Complaintele.subResone, '', 'Complaint')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Complaintele.Name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
      staticClass: "comp_number"
    }, [_c('a', {
      attrs: {
        "href": '#/b2b/dashboard'
      },
      on: {
        "click": function($event) {
          _vm.showSummaryTicketData1(Complaintele.subResone, '', 'Complaint')
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Complaintele.Values) + "\n\t\t\t\t\t\t")])])])
  }), _vm._v(" "), (_vm.TicketsSummery.Complaint.TotalCound <= 0) ? _c('div', [_c('div', {
    staticClass: "text-center text-muted text-uppercase font-weight-bold font-xs"
  }, [_vm._v("No\n\t\t\t\t\t\ttickets\n\t\t\t\t\t")])]) : _vm._e()], 2)])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon orange_background"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('p', {
    staticClass: "text_head"
  }, [_vm._v("Enquiry")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon green_background"
  }, [_c('i', {
    staticClass: "fa fa-comments",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('p', {
    staticClass: "text_head"
  }, [_vm._v("Request")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon red_background"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('p', {
    staticClass: "text_head"
  }, [_vm._v("Complaint")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-582fc40e","hasScoped":true}!./src/views/components/b2b/b2bdashboard/b2bdashboard.component.html
// module id = 928
// module chunks = 1